// Route paths as constants for type safety and easy refactoring
// This file is separate from router.tsx to avoid circular imports
export const ROUTES = {
  HOME: '/',
  COMPLAINTS: '/complaints',
  SUBMIT_COMPLAINT: '/complaints/new',
  COMPLAINT_DETAIL: '/complaints/:id',
  ANALYTICS: '/analytics',
  STORES: '/stores',
  ADMIN: '/admin',
  VENDOR_ADMIN: '/team', // Vendor self-service admin (labeled as "Team Management")
  SETTINGS: '/settings',
} as const;

// Map route paths to page keys for navigation highlighting
export function getPageKeyFromPath(pathname: string): string {
  // Complaints is now the default/home page (dashboard merged into complaints)
  if (pathname === '/' || pathname === '/complaints' || pathname === '/dashboard') return 'complaints';
  if (pathname === '/complaints/new') return 'submit-complaint';
  if (pathname.startsWith('/complaints')) return 'complaints';
  if (pathname === '/analytics') return 'analytics';
  if (pathname === '/stores') return 'stores';
  if (pathname === '/admin') return 'admin';
  if (pathname === '/team') return 'team'; // Vendor self-service admin
  if (pathname === '/settings') return 'settings';
  return 'complaints';
}
